<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        <div class="d-flex justify-content-between my-3">
          <p class="fs-6 m-2">
            {{ this.$route.meta.title }}
          </p>
          <router-link
            v-if="formData.id"
            class="btn btn-primary btn-block"
            :to="{ name: 'AddProducts' }"
          >
            <i class="fas fa-plus"></i>
            محصول جدید
          </router-link>
        </div>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
        <form class="row" id="productFrm">
          <div class="col-md-4 col-xs-6">
            <div class="form-floating mb-3">
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                placeholder="نام محصول"
                v-model="formData.name"
              />
              <label for="name">نام *</label>
            </div>
          </div>

          <div class="col-md-4 col-xs-6">
            <div class="form-floating mb-3">
              <select
                class="form-control"
                id="type"
                name="type"
                v-model="formData.type"
              >
                <option value="normal">عادی</option>
                <option value="video">ویدیو</option>
                <option value="chairs">همایش</option>
                <option value="download">دانلودی</option>
                <option value="package">پکیج</option>
              </select>
              <label for="type">نوع</label>
            </div>
          </div>

          <div class="col-md-1 col-xs-6">
            <div class="form-floating mb-3">
              <select
                class="form-control"
                id="published"
                name="published"
                v-model="formData.published"
              >
                <option value="1" :selected="formData.published == 1">
                  بله
                </option>
                <option value="0" :selected="formData.published == 0">
                  خیر
                </option>
              </select>
              <label for="published">انتشار</label>
            </div>
          </div>

          <div class="col-md-3 col-xs-6">
            <div for="published">تاریخ درج</div>
            <input
              id="order_date"
              name="order_date"
              v-model="state.order_date"
              :key="orderDateKey"
            />
          </div>

          <div class="col-md-4 col-xs-6">
            <div class="form-floating mb-3">
              <input
                type="number"
                class="form-control"
                id="price"
                name="price"
                placeholder="قیمت"
                v-model="formData.price"
              />
              <label for="name">قیمت</label>
            </div>
          </div>

          <div class="col-md-4 col-xs-6">
            <div class="form-floating mb-3">
              <input
                type="number"
                class="form-control"
                id="sale_price"
                name="sale_price"
                placeholder="قیمت"
                v-model="formData.sale_price"
              />
              <label for="name">قیمت فروش</label>
            </div>
          </div>
          <div class="col-md-4 col-xs-6">
            <label v-show="showDate" for="name"> تاریخ انقضا</label>
            <DatePicker
              id="sale_expire"
              name="sale_expire"
              v-show="showDate"
              v-model="state.date"
              :key="datePickerKey"
            />
            <br />
            <input
              type="checkbox"
              :checked="!showDate"
              @click="showDate = !showDate"
            />
            بدون تاریخ انقضا
          </div>

          <div class="col-md-4 col-xs-6">
            <div class="form-floating mb-3">
              <select
                class="form-control"
                id="category_ones_id"
                name="category_ones_id"
                v-model="formData.category_ones_id"
                @change="filterCategoryTwos($event)"
              >
                <option
                  v-for="item in categoryOnesList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <label for="category_ones_id">دسته سطح اول</label>
            </div>
          </div>

          <div class="col-md-4 col-xs-6">
            <div class="form-floating mb-3">
              <select
                class="form-control"
                id="category_twos_id"
                name="category_twos_id"
                v-model="formData.category_twos_id"
                @change="filterCategoryThrees($event)"
              >
                <option
                  v-for="item in categoryTwosList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <label for="category_twos_id">دسته سطح دو</label>
            </div>
          </div>

          <div class="col-md-4 col-xs-6">
            <div class="form-floating mb-3">
              <select
                class="form-control"
                id="category_threes_id"
                name="category_threes_id"
                v-model="formData.category_threes_id"
              >
                <option
                  v-for="item in categoryThreesList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <label for="category_threes_id">دسته سطح سه</label>
            </div>
          </div>

          <div class="col-md-8 col-xs-12">
            <label for="short_description">توضیحات کوتاه</label>
            <textarea
              class="form-control"
              rows="3"
              id="short_description"
              name="short_description"
              v-model="formData.short_description"
            ></textarea>
          </div>

          <div class="col-md-4 col-xs-12">
            <div v-if="formData.id">
              <label for="main_image_path" class="form-label">
                تصویر اصلی محصول
              </label>
              <a
                :href="API_STORAGE_URL + formData.main_image_path"
                target="_blank"
              >
                <img
                  v-if="formData.main_image_path"
                  :src="API_STORAGE_URL + formData.main_image_path"
                  class="img-thumbnail"
                  style="width: 100"
                />
              </a>
              <input
                class="form-control form-control-sm my-1"
                id="main_image_path"
                type="file"
                @change="addUploadImage($event)"
              />

              <div class="mt-2">
                <a
                  class="btn btn-sm btn-success"
                  @click="setProductMainImage()"
                >
                  <i class="fas fa-plus"></i>
                  ذخیره تصویر
                </a>

                <span
                  v-show="showFileSpin"
                  class="fas fa-spinner fa-spin mt-3"
                ></span>

                <a
                  v-show="formData.main_image_path"
                  class="btn btn-sm btn-danger mx-1"
                  @click="deleteProductMainImage()"
                >
                  <i class="fas fa-trash"></i>
                  حذف تصویر
                </a>
              </div>
            </div>
            <span v-else> پس از ذخیره محصول امکان درج تصویر فراهم است </span>
          </div>

          <div class="col-md-8 col-xs-12 my-3">
            <label for="long_description">توضیحات بلند</label>
            <textarea
              class="form-control"
              rows="4"
              cols="50"
              id="long_description"
              name="long_description"
              v-model="formData.long_description"
            ></textarea>
          </div>

          <div class="col-md-4 col-xs-12">
            <div v-if="formData.id">
              <label class="form-label mt-3"> فایل/ها </label>
              <div
                v-for="item in formData.files"
                :key="item.id"
                class="border d-flex justify-content-between mt-1 p-2 rounded-1"
              >
                <a :href="API_STORAGE_URL + item.file_path" target="_blank">
                  {{ item.name }}
                </a>
                <a class="text-danger mx-1" @click="deleteFile(item.id)">
                  <i class="fas fa-trash"></i>
                </a>
              </div>

              <div class="col-md-12 col-xs-12 mt-1">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control"
                    id="file_name"
                    placeholder="نام فایل"
                    v-model="fileName"
                  />
                  <label for="file_name"> عنوان فایل </label>
                </div>
              </div>

              <input
                class="form-control form-control-sm my-1"
                id="product_file"
                type="file"
                @change="addUploadFile($event)"
              />
              <div class="my-2">
                <a class="btn btn-sm btn-success" @click="setProductFile()">
                  <i class="fas fa-plus"></i>
                  ذخیره فایل
                </a>

                <span
                  v-show="showFileSpin"
                  class="fas fa-spinner fa-spin mt-3"
                ></span>
              </div>
            </div>
            <span v-else> پس از ذخیره محصول امکان درج فایل فراهم است </span>
          </div>

          <div class="col-md-3 col-xs-12">
            <div class="form-floating mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="روزهای برگزاری"
                v-model="formData.days"
              />
              <label>روزهای برگزاری </label>
            </div>
          </div>

          <div class="col-md-3 col-xs-12">
            <div class="form-floating mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="ساعت برگزاری"
                v-model="formData.hour"
              />
              <label>ساعت برگزاری </label>
            </div>
          </div>

          <div class="col-md-3 col-xs-12">
            <div class="form-floating mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="تاریخ شروع"
                v-model="formData.start_date"
              />
              <label>تاریخ شروع </label>
            </div>
          </div>

          <div class="col-md-3 col-xs-12">
            <div class="form-floating mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="نظام تحصیلی"
                v-model="formData.education_system"
              />
              <label>نظام تحصیلی</label>
            </div>
          </div>

          <div class="col-md-3 col-xs-6">
            <div class="form-floating mb-3">
              <select class="form-control" v-model="formData.special">
                <option value="1" :selected="formData.special == 1">بله</option>
                <option value="0" :selected="formData.special == 0">خیر</option>
              </select>
              <label>ویژه</label>
            </div>
          </div>
        </form>
        <div class="d-flex justify-content-between mb-2">
          <a
            v-if="showSaveBtn"
            class="btn btn-primary btn-block"
            @click="addEditProduct()"
          >
            ثبت
            <span v-show="showSpin" class="fas fa-spinner fa-spin mt-3"></span>
          </a>

          <router-link
            v-if="formData.id"
            class="btn btn-primary btn-block"
            :to="{ name: 'AddProducts' }"
          >
            <i class="fas fa-plus"></i>
            محصول جدید
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../components/TheSidemenu";
import TheTopmenu from "../components/TheTopmenu";
import ArefApi from "../libs/api.js";

import DatePicker from "vue3-persian-datepicker";
import "vue3-persian-datepicker/dist/datepicker.min.css";
import { reactive } from "@vue/reactivity";
import jmoment from "moment-jalaali";
import utils from "../libs/utils";

export default {
  name: "AddProduct",
  components: {
    TheSidemenu,
    TheTopmenu,
  },
  setup() {
    const state = reactive({
      date: jmoment().format("jYYYY/jMM/jDD"),
      order_date: "",
    });

    return {
      DatePicker,
      state,
    };
  },
  created() {
    this.arefApi = new ArefApi();
    this.jmoment = jmoment;
    this.utils = new utils();
  },
  data() {
    return {
      error: null,
      showSpin: false,
      showFileSpin: false,
      showSaveBtn: true,
      formData: {
        id: this.$route.params.productId ? this.$route.params.productId : null,
        name: null,
        short_description: null,
        long_description: null,
        price: null,
        sale_price: null,
        sale_expire: null,
        category_ones_id: null,
        category_twos_id: null,
        category_threes_id: null,
        main_image_path: null,
        second_image_path: null,
        published: null,
        type: null,
        special: 0,
        education_system: null,
        hour: null,
        days: null,
        start_date: null,
        files: [],
        order_date: null,
      },
      cities: null,
      main_image_file: null,
      API_STORAGE_URL: process.env.VUE_APP_API_STORAGE_URL,
      categoryOnesList: null,
      categoryTwosList: null,
      categoryThreesList: null,
      showDate: false,
      productFile: null,
      fileName: null,
      datePickerKey: "0",
      orderDateKey: 2000,
    };
  },
  methods: {
    addEditProduct() {
      if (!this.validateFrm()) {
        return;
      }
      this.showSpin = true;
      const fn = this.formData.id ? "editProduct" : "addProduct";
      this.formData.category_ones_id = Number(this.formData.category_ones_id);
      this.formData.category_twos_id = this.formData.category_twos_id
        ? Number(this.formData.category_twos_id)
        : null;
      this.formData.category_threes_id = this.formData.category_threes_id
        ? Number(this.formData.category_threes_id)
        : null;
      this.formData.sale_expire = this.showDate
        ? this.formData.sale_expire
        : null;
      if (this.formData.sale_expire) {
        this.formData.sale_expire = jmoment(
          this.formData.sale_expire,
          "jYYYY/jM/jD"
        ).format("YYYY-M-D");
      }

      this.formData.order_date = jmoment(
        this.state.order_date,
        "jYYYY/jM/jD"
      ).format("YYYY-M-D");

      this.arefApi[fn](this.formData)
        .then((resp) => {
          this.$swal
            .fire({
              title: "",
              text: `ثبت محصول با موفقیت انجام شد`,
              icon: "success",
              confirmButtonText: "متوجه شدم",
            })
            .then((res) => {
              if (res.isConfirmed && !this.formData.id) {
                this.formData.id = resp.data.id;
                this.$router.push({
                  name: "EditProduct",
                  params: { productId: resp.data.id },
                });
              }
            });
        })
        .catch((err) => {
          let alertText = "";
          if (err.data.errors) {
            for (let i in err.data.errors) {
              alertText += (alertText ? "" : ",") + `${err.data.errors[i]} `;
            }
          }
          this.$swal.fire({
            title: "!خطا",
            text: `${alertText}`,
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
        })
        .finally(() => {
          this.showSpin = false;
        });
    },
    addUploadImage(event) {
      this.main_image_file = event.target.files[0];
    },
    addUploadFile(event) {
      this.productFile = event.target.files[0];
    },
    setProductMainImage() {
      this.error = null;
      if (!this.main_image_file) {
        this.error = "فایل تصویر را انتخاب فرمایید";
        return;
      }

      this.showFileSpin = true;
      let formDataTmp = new FormData();
      formDataTmp.append("main_image_path", this.main_image_file);
      this.arefApi
        .setProductMainImage(formDataTmp, this.formData.id)
        .then(() => {
          this.$swal.fire({
            title: "",
            text: `ثبت تصویر با موفقیت انجام شد`,
            icon: "success",
            confirmButtonText: "متوجه شدم",
          });
          this.loadProductInfo();
          document.getElementById("main_image_path").value = "";
          this.main_image_file = null;
        })
        .catch((err) => {
          let alertText = "";
          if (err.data.errors) {
            for (let i in err.data.errors) {
              alertText += (alertText ? "" : ",") + `${err.data.errors[i]} `;
            }
          }
          this.$swal.fire({
            title: "!خطا",
            text: `${alertText}`,
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
        })
        .finally(() => {
          this.showFileSpin = false;
        });
    },
    deleteProductMainImage() {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteProductMainImage(this.formData.id)
              .then(() => {
                this.$swal.fire({
                  title: "",
                  text: `حذف تصویر با موفقیت انجام شد`,
                  icon: "success",
                  confirmButtonText: "متوجه شدم",
                });
                this.loadProductInfo();
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    setProductFile() {
      this.error = null;
      if (!this.fileName) {
        this.error = "نام فایل را انتخاب فرمایید";
        return;
      }
      if (!this.productFile) {
        this.error = "فایل  را انتخاب فرمایید";
        return;
      }

      this.showFileSpin = true;
      let formDataTmp = new FormData();
      formDataTmp.append("file", this.productFile);
      formDataTmp.append("name", this.fileName);
      formDataTmp.append("products_id", this.formData.id);
      this.arefApi
        .setProductFile(formDataTmp)
        .then(() => {
          this.$swal.fire({
            title: "",
            text: `ثبت فایل با موفقیت انجام شد`,
            icon: "success",
            confirmButtonText: "متوجه شدم",
          });
          this.loadProductInfo();
          document.getElementById("product_file").value = "";
          this.fileName = null;
          this.productFile = null;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.showFileSpin = false;
        });
    },
    deleteFile(fileId) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteProductFile(fileId)
              .then(() => {
                this.$swal.fire({
                  title: "",
                  text: `حذف فایل با موفقیت انجام شد`,
                  icon: "success",
                  confirmButtonText: "متوجه شدم",
                });
                this.loadProductInfo();
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    validateFrm() {
      this.error = null;
      if (!this.formData.name || this.formData.name.length < 3) {
        this.error = "نام باید بیشتر از دو حرف باشد";
        return false;
      }

      if (!this.formData.type) {
        this.error = "نوع محصول را انتخاب کنید";
        return false;
      }

      if (!this.formData.category_ones_id) {
        this.error = "سته سطح اول را وارد کنید";
        return false;
      }

      if (!this.formData.published) {
        this.error = "وضعیت انتشار محصول را انتخاب کنید";
        return false;
      }

      if (!this.formData.price || Number(this.formData.price) < 0) {
        this.error = "قیمت را وارد کنید";
        return false;
      }

      return true;
    },
    async loadProductInfo() {
      return new Promise((resolve, reject) => {
        this.arefApi
          .getProduct(this.formData.id)
          .then((resp) => {
            this.formData = resp.data;
            this.formData.category_ones_id = resp.data.category_one.id;
            this.formData.category_twos_id = resp.data.category_two
              ? resp.data.category_two.id
              : null;
            this.formData.category_threes_id = resp.data.category_three
              ? resp.data.category_three.id
              : null;

            this.showDate = !!this.formData.sale_expire;

            this.state.order_date = resp.data.order_date
              ? jmoment(resp.data.order_date).format("jYYYY/jMM/jDD")
              : jmoment().format("jYYYY/jMM/jDD");
            this.orderDateKey++;
            resolve();
          })
          .catch(() => {
            this.$swal
              .fire({
                title: "خطا!",
                text: "محصول پیدا نشد ",
                icon: "error",
              })
              .then(() => {
                this.$router.push({ name: "ProductsList" });
              });
            reject();
          });
      });
    },
    async getCategoryOnesList() {
      try {
        let res = await this.arefApi.getCategoryonesIndex(1, true);
        this.categoryOnesList = res.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getCategoryTwosList() {
      if (!this.formData.category_ones_id) {
        return;
      }
      try {
        let res = await this.arefApi.getCategoryoneSubset(
          this.formData.category_ones_id
        );
        if (res.data.length) {
          this.categoryTwosList = res.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getCategoryThreesList() {
      if (!this.formData.category_twos_id) {
        return;
      }
      try {
        let res = await this.arefApi.getCategorytwoSubset(
          this.formData.category_twos_id
        );
        this.categoryThreesList = res.data;
      } catch (e) {
        console.log(e);
      }
    },
    filterCategoryTwos(event) {
      this.formData.category_threes_id = null;
      this.formData.category_ones_id = event.target.value;
      this.getCategoryTwosList();
    },
    filterCategoryThrees(event) {
      this.formData.category_twos_id = event.target.value;
      this.getCategoryThreesList();
    },
    async pageLoad() {
      if (this.formData.id) {
        await this.loadProductInfo();
        this.state.date = this.formData.sale_expire
          ? jmoment(this.formData.sale_expire).format("jYYYY/jMM/jDD")
          : jmoment().format("jYYYY/jMM/jDD");
        this.datePickerKey = this.formData.id.toString();
      }
      this.getCategoryOnesList();
      this.getCategoryTwosList();
      this.getCategoryThreesList();
    },
  },
  async mounted() {
    this.pageLoad();
  },
  watch: {
    $route(to, from) {
      if (to.name != from.name && to.name == "AddProducts") {
        this.$router.go(this.$router.currentRoute);
      }
    },
  },
};
</script>
